export const STANDARD_DATE_FORMAT = 'DD/MM/YYYY';
export const EXCESS_TRANSITION_DATE = '2023-08-21';
export const ONLINE_DISCOUNT_KEY = 'SS_OnlineDiscount';
export const JP_GENERIC_CODE = 'JP_GENERIC';
export const JP_LOGGED_OUT_CODE = 'JP_LOGGEDOUT';
export const JP_DOD_DISAGREE_KEY = 'JP_DOD_DISAGREE';
export const JP_CHANGE_NOT_ALLOWED_CODE = 'JP_CHANGENOTALLOWED';
